import { render } from "./update_category_component.vue?vue&type=template&id=60aaf24c&scoped=true"
import script from "./update_category_component.vue?vue&type=script&lang=js"
export * from "./update_category_component.vue?vue&type=script&lang=js"

import "./update_category_component.vue?vue&type=style&index=0&id=60aaf24c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60aaf24c"]])

export default __exports__